import React, {Component} from "react";
import {connect} from "react-redux";

class VideoBanner extends Component {
    render() {
        let currentVideo = this.props.currentVideo;
        let online = this.props.online?<span className="video-banner-online">{this.props.online} Watching</span>:'';
        return !currentVideo ? <div className="video-banner"></div> :
            <div className="video-banner">
                <span className="video-banner-name">{currentVideo.name}</span>
                {online}
                <span className="video-banner-comments">{currentVideo.comments || 0} Comments</span>
                <span className="video-banner-views">{currentVideo.views || 0} Views</span>
                <span
                    className="video-banner-time">{currentVideo.time && new Date(currentVideo.time).toUTCString()}</span>
            </div>;
    }
}
let mapStateToProps = (state) => {
    return {
        currentVideo: state.currentVideo,
        online: state.online
    };
};
export default connect(mapStateToProps)(VideoBanner);


// WEBPACK FOOTER //
// ./src/componentsBody/VideoBanner.js